"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DocumentType = require("../living/generated/DocumentType");

var DocumentFragment = require("../living/generated/DocumentFragment");

var Text = require("../living/generated/Text");

var Comment = require("../living/generated/Comment");

var attributes = require("../living/attributes");

var nodeTypes = require("../living/node-type");

var serializationAdapter = require("./parse5-adapter-serialization");

module.exports = /*#__PURE__*/function () {
  function JSDOMParse5Adapter(documentImpl) {
    _classCallCheck(this, JSDOMParse5Adapter);

    this._documentImpl = documentImpl;
  }

  _createClass(JSDOMParse5Adapter, [{
    key: "createDocument",
    value: function createDocument() {
      // parse5's model assumes that parse(html) will call into here to create the new Document, then return it. However,
      // jsdom's model assumes we can create a Window (and through that create an empty Document), do some other setup
      // stuff, and then parse, stuffing nodes into that Document as we go. So to adapt between these two models, we just
      // return the already-created Document when asked by parse5 to "create" a Document.
      return this._documentImpl;
    }
  }, {
    key: "createDocumentFragment",
    value: function createDocumentFragment() {
      return DocumentFragment.createImpl([], {
        ownerDocument: this._documentImpl
      });
    }
  }, {
    key: "createElement",
    value: function createElement(localName, namespace, attrs) {
      var element = this._documentImpl._createElementWithCorrectElementInterface(localName, namespace);

      element._namespaceURI = namespace;
      this.adoptAttributes(element, attrs);

      if ("_parserInserted" in element) {
        element._parserInserted = true;
      }

      return element;
    }
  }, {
    key: "createCommentNode",
    value: function createCommentNode(data) {
      return Comment.createImpl([], {
        data: data,
        ownerDocument: this._documentImpl
      });
    }
  }, {
    key: "appendChild",
    value: function appendChild(parentNode, newNode) {
      parentNode.appendChild(newNode);
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(parentNode, newNode, referenceNode) {
      parentNode.insertBefore(newNode, referenceNode);
    }
  }, {
    key: "setTemplateContent",
    value: function setTemplateContent(templateElement, contentFragment) {
      templateElement._templateContents = contentFragment;
    }
  }, {
    key: "setDocumentType",
    value: function setDocumentType(document, name, publicId, systemId) {
      // parse5 sometimes gives us these as null.
      if (name === null) {
        name = "";
      }

      if (publicId === null) {
        publicId = "";
      }

      if (systemId === null) {
        systemId = "";
      }

      var documentType = DocumentType.createImpl([], {
        name: name,
        publicId: publicId,
        systemId: systemId,
        ownerDocument: this._documentImpl
      });
      document.appendChild(documentType);
    }
  }, {
    key: "setDocumentMode",
    value: function setDocumentMode(document, mode) {
      // TODO: the rest of jsdom ignores this
      document._mode = mode;
    }
  }, {
    key: "detachNode",
    value: function detachNode(node) {
      node.remove();
    }
  }, {
    key: "insertText",
    value: function insertText(parentNode, text) {
      var lastChild = parentNode.lastChild;

      if (lastChild && lastChild.nodeType === nodeTypes.TEXT_NODE) {
        lastChild.data += text;
      } else {
        var textNode = Text.createImpl([], {
          data: text,
          ownerDocument: this._documentImpl
        });
        parentNode.appendChild(textNode);
      }
    }
  }, {
    key: "insertTextBefore",
    value: function insertTextBefore(parentNode, text, referenceNode) {
      var previousSibling = referenceNode.previousSibling;

      if (previousSibling && previousSibling.nodeType === nodeTypes.TEXT_NODE) {
        previousSibling.data += text;
      } else {
        var textNode = Text.createImpl([], {
          data: text,
          ownerDocument: this._documentImpl
        });
        parentNode.insertBefore(textNode, referenceNode);
      }
    }
  }, {
    key: "adoptAttributes",
    value: function adoptAttributes(element, attrs) {
      var _iterator = _createForOfIteratorHelper(attrs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          var prefix = attr.prefix === "" ? null : attr.prefix;
          attributes.setAttributeValue(element, attr.name, attr.value, prefix, attr.namespace);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return JSDOMParse5Adapter;
}();

Object.assign(module.exports.prototype, serializationAdapter);